import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {HttpClientService} from "./http-client.service";
import {HttpParams} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class ImagesService {

  constructor(private http: HttpClientService) { }

  public uploadImage(formData: FormData): Observable<any> {
    const file = formData.get('file') as File;
    const url = `/images/upload?file=${file.name}`;
    //{responseType: 'text'}
    return this.http.post(url, formData);
  }

  public uploadImageForLuminarie(formData: FormData, empresa: string): Observable<any> {
    const file = formData.get('file') as File;
    formData.set("empresa", empresa);
    const url = `/images/uploadforluminarie?file=${file.name}`;
    //{responseType: 'text'}
    return this.http.post(url, formData);
  }

  public updateImageName(idImagen: string, name: string): Observable<any> {
    let body =
      {
        "idImagen": idImagen,
        "name": name
      };
    return this.http.patch('/images/updateimagename', body);
  }

  public getImagenesByEmpresa(idEmpresa) {
    let params = new HttpParams().set("idEmpresa", idEmpresa);
    return this.http.getWithParams('/images/getimagenesbyempresa', params);
  }

}
